import { render, staticRenderFns } from "./ArtBuyers.vue?vue&type=template&id=9146bc60&lang=html"
import script from "./ArtBuyers.vue?vue&type=script&lang=js"
export * from "./ArtBuyers.vue?vue&type=script&lang=js"
import style0 from "./ArtBuyers.vue?vue&type=style&index=0&id=9146bc60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports